// Libs
import React from 'react'
import { Archive, Check } from 'react-feather'

// CSS
import './styles.scss'

const CaptureConfirmCard = ({ lawsuit, type }) => {
  let greyColor = '#434343'
  let greenColor = '#12B7A3'

  return (
    <div className='capture-card-confirm'>
      {type === 'archive' ?
        <div className='capture-card-confirm__content'>
          <Archive size={50} color={greyColor} />
          <div>{lawsuit.number}</div>
          <span>Caso arquivado com sucesso!</span>
        </div>
        :
        <div className='capture-card-confirm__content'>
          <Check size={70} color={greenColor} />
          <div>{lawsuit.number}</div>
          <span>Caso inserido com sucesso!</span>
        </div>
      }
    </div>
  )
}

export default CaptureConfirmCard
